import type { RateInfo } from '../../types/electricity'
import { appliances } from '../../data/appliances'
import { RATES } from '../../data/rates'
import { useLanguage } from '../../i18n/LanguageContext'
import { translations } from '../../i18n/translations'

interface Props {
  rate: RateInfo
  onSeeMore?: () => void
}

export function QuickAdvice({ rate, onSeeMore }: Props) {
  const { lang, t } = useLanguage()

  const deferrables = appliances.filter((a) => a.deferrable)
  const pick = deferrables.reduce((a, b) => (a.watts > b.watts ? a : b))
  const seasonRates = RATES[rate.season]
  const savingPerHour = (pick.watts / 1000) * (seasonRates.peak - seasonRates.offpeak) / 100
  const savingStr = savingPerHour.toFixed(2)
  const applianceName = t(`appliances.${pick.id}` as 'appliances.ac') as string

  const isPeak = rate.tier === 'peak'
  const adviceFn = isPeak ? translations.quickAdvice.waitFor[lang] : translations.quickAdvice.runNow[lang]
  const adviceText = adviceFn(applianceName, savingStr)

  return (
    <div className="mt-3 text-center">
      <p className={`text-sm font-bold ${isPeak ? 'text-red-400' : 'text-emerald-400'}`}>
        {adviceText}
      </p>
      {onSeeMore && (
        <button
          onClick={onSeeMore}
          className="text-xs text-slate-400 hover:text-slate-300 mt-1 underline underline-offset-2 transition-colors"
        >
          {t('quickAdvice.seeMore') as string}
        </button>
      )}
    </div>
  )
}
